import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class NetworkSessionService {
  constructor(private http: HttpClient) {}

  getNetworkSessionData(): Observable<any> {
    const get_url = baseApiUrl + 'dbcdrprocessing';
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  getNetworkSessionDataByDate(network_session_data: any): Observable<any> {
    const post_url = baseApiUrl + 'subscriber/getDbcdrProcessing';
    return this.http.post<any>(post_url, network_session_data, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
  }
}